module.exports = __webpack_public_path__ + "img/eyeball.1a55f278.svg";